import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

export const fetchReportStatus = (searchParams) =>
  getNetwork().get(`${API_ROOT}/edu-report/status?${searchParams}`);

export const fetchReportKinds = () =>
  getNetwork().get(`${API_ROOT}/edu-report/kind`);
